function initializeMenu() {
  const menuButtons = $('.js-menu-button');

  if (!menuButtons.length) {
    return;
  }

  // .off().on() kvůli Livewire navigaci,
  // aby se click event nenavěsil víckrát.
  menuButtons.off('click.volvistaMenu').on('click.volvistaMenu', function (e) {
    e.preventDefault();

    const shouldOpenMenu = !$('body').hasClass('menu-active');

    $('body').toggleClass('menu-active', shouldOpenMenu);
    menuButtons.toggleClass('is-active', shouldOpenMenu);
  });
}


// ---------------------------------------------
// Header scroll behavior
// ---------------------------------------------

const header = document.querySelector('.header');
const body = document.body;
const root = document.documentElement;

const delta = 5;

let lastScroll = 0;
let ticking = false;

// Threshold = od jaké pozice scrollu se má header přepnout
// do redesign / scrolled stavu.
let threshold = 152;

// Na mobilech je header jinak vysoký,
// proto může být potřeba jiný threshold.
if (window.innerWidth < 992) {
  threshold = 124;
}

if (window.innerWidth < 576) {
  threshold = 159;
}


// Synchronizace tříd a CSS proměnných.
// Tohle se hodí např. pro odsazení obsahu podle výšky headeru.
function syncHeaderMetrics() {
  if (!header) {
    return;
  }

  body.classList.toggle(
    'header-redesign',
    header.classList.contains('header--volvista-redesign')
  );

  body.classList.toggle(
    'header-at-top',
    header.classList.contains('header--at-top')
  );

  body.classList.toggle(
    'header-scrolled',
    header.classList.contains('header--scrolled')
  );

  root.style.setProperty('--header-height', `${header.offsetHeight}px`);
}


// Zavře otevřené mobilní menu.
// Používá se při změně stavu headeru.
function closeMenu() {
  body.classList.remove('menu-active');

  document.querySelectorAll('.js-menu-button').forEach((button) => {
    button.classList.remove('is-active');
  });
}


// Vyvolání custom eventu, pokud na změnu headeru
// potřebuje reagovat jiný script.
function dispatchHeaderStateChanged(isScrolled) {
  document.dispatchEvent(
    new CustomEvent('volvista:header-state-changed', {
      detail: {
        isScrolled,
      },
    })
  );
}


// Hlavní funkce pro aktualizaci headeru.
function updateHeader() {
  if (!header) {
    return;
  }

  const currentScroll = window.scrollY;
  const diff = currentScroll - lastScroll;

  const isAfterThreshold = currentScroll > threshold;
  const hadScrolledState = header.classList.contains('header--scrolled');
  const isResponsiveCarDetail = body.classList.contains('page--car-detail') && window.innerWidth < 1200;
  const shouldHideCommonHeaderOnScroll = isAfterThreshold && (window.innerWidth < 576 || isResponsiveCarDetail);

  // ---------------------------------------------
  // Varianta: common header
  // ---------------------------------------------
  // Header začíná jako .header--volvista-common.
  // Redesign se má přidat až po překročení threshold,
  // ne hned při scrollY > 0.
  if (header.classList.contains('header--volvista-common')) {
    header.classList.toggle('header--scrolled', isAfterThreshold);
    header.classList.toggle('header--at-top', !isAfterThreshold);
    header.classList.toggle('header--volvista-redesign', isAfterThreshold);

    // Common/redesign varianta se nemá schovávat jako compact header.
    header.classList.remove('header--compact');

    if (shouldHideCommonHeaderOnScroll) {
      const isScrollingDown = diff > 0;
      const isScrollingUp = diff < 0;
      const shouldKeepHeaderVisible = body.classList.contains('menu-active')
        || header.classList.contains('header--search-open');

      if (shouldKeepHeaderVisible || isScrollingUp) {
        header.classList.add('header--showed');
        body.classList.remove('header-hidden');
      } else if (isScrollingDown) {
        header.classList.remove('header--showed');
        body.classList.add('header-hidden');
      }
    } else {
      header.classList.add('header--showed');
      body.classList.remove('header-hidden');
    }

    // Pokud se změnil stav top/scrolled, zavřeme menu
    // a pošleme event ostatním scriptům.
    if (hadScrolledState !== isAfterThreshold) {
      closeMenu();
      dispatchHeaderStateChanged(isAfterThreshold);
    }

    syncHeaderMetrics();

    lastScroll = currentScroll;
    ticking = false;
    return;
  }

  // ---------------------------------------------
  // Standardní scrollování ostatních headerů
  // ---------------------------------------------

  if (isAfterThreshold) {
    header.classList.add('header--compact');
  } else {
    header.classList.remove('header--compact');
  }

  syncHeaderMetrics();

  // Ignorování mikro pohybů kvůli trackpadům / jemnému scrollu.
  if (Math.abs(diff) <= delta) {
    ticking = false;
    return;
  }

  // Pokud už je header redesign, nemá se schovávat.
  if (header.classList.contains('header--volvista-redesign')) {
    body.classList.remove('header-hidden');

    lastScroll = currentScroll;
    syncHeaderMetrics();
    ticking = false;
    return;
  }

  const isScrollingDown = diff > 0;

  if (isScrollingDown) {
    header.classList.remove('header--showed');
    body.classList.add('header-hidden');
  } else {
    // Header se ukáže při scrollu nahoru až po překročení threshold.
    if (isAfterThreshold) {
      header.classList.add('header--showed');
      body.classList.remove('header-hidden');
    }
  }

  lastScroll = currentScroll;
  syncHeaderMetrics();
  ticking = false;
}


// ---------------------------------------------
// Init
// ---------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  initializeMenu();
  updateHeader();
});

document.addEventListener('livewire:navigated', function () {
  initializeMenu();
  updateHeader();
});

window.addEventListener('load', updateHeader);

window.addEventListener('resize', function () {
  syncHeaderMetrics();
});

window.addEventListener('scroll', function () {
  if (!ticking) {
    requestAnimationFrame(updateHeader);
    ticking = true;
  }
});
